import { render, staticRenderFns } from "./Aposentadorias.vue?vue&type=template&id=3a1fb3ea"
import script from "./Aposentadorias.vue?vue&type=script&lang=ts"
export * from "./Aposentadorias.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports